<template>
    <!-- <div style="background: #f9f9f9" :style="{ height: parkHeight }"> -->
    <div style="background: #f9f9f9" :style="{ height: parkHeight }">
        <div class="tittle">
			 <div class="titletop flex">
            <div class="logo fl">
                <img
                    src="../../assets/logo.png"
                    alt=""
                    @click="getRegisteredLogin(1)"
                />
            </div>
            <div class="login flex">
                <div class="lh90" @click="getRegisteredLogin(1)">首页</div>
                <!-- <div class="lh90" @click="getRegisteredLogin(2)">帮助中心</div> -->
				<div class="lh90" @click="getRegisteredLogin(2)">文档</div>
			</div>
        </div>
        </div>
        
        <div style="height: 86px"></div>
        <div class="registered">
            <div class="registeredTop flex">
                <h3>注册成功</h3>
            </div>
            <div class="regBox">
                <p class="el-icon-circle-check regIcon"></p>
                <p class="regSuccess">注册成功</p>
                <p class="regUsername">登录名：{{ userMessages.name }}</p>
                <p class="regTel">绑定手机号：{{ userMessages.tel }}</p>
                <p class="regMess">完成实名认证，享受更多增材云服务</p>
                <div class="regButton">
                    <button @click="getReturngo">返回注册前页面</button>
                    <button @click="toAuthentication">快速实名认证</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import {getNewcurrent} from "../../utils/interface";
    
    export default {
        //  注册成功
        name: "regSuccess",
        data() {
            return {
                userMessages: {},
            };
        },
        created() {
            this.parkHeight = document.documentElement.clientHeight + "px";
            this.vuexAllPark(false);
        },
        watch: {},
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
            }),
        },
        mounted() {
            getNewcurrent()
                .then((res) => {
                    // console.log("用户信息", res);
                    this.userMessages = res;
                    // this.userName = res.name;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        methods: {
            ...mapMutations(["vuexAllPark", "isLoginVuex"]),
            // 顶部跳转
            getRegisteredLogin(num) {
                if (num == 1) {
                    this.$router.push("/");
                }else if (num == 2){
                    this.$router.push("/helpCenter");
                }
            },
            getReturngo() {
                // if(location.href.indexOf("registered") != -1 ||
                //   location.href.indexOf("login")!= -1){
                //     console.log('777', );
                // }
                // this.$router.push("/");
			    this.$router.go(-2);
            },
            toAuthentication() {
                window.sessionStorage.setItem("userServeId",'10')
                this.$router.push("/userCenter/10");

                // this.$router.push({
                //     name: "/userCenter",
                //     // params: { userServeId: '00'}
                // })
            }
        },
    };
</script>

<style scoped lang="less">
    .blue {
        color: #1181ff;
    }
    
    .red {
        color: #d60000;
    }
    
    .registered {
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        border-radius: 10px;
        
        .registeredTop {
            border-bottom: 1px solid #f9f9f9;
            padding: 18px 30px 18px 44px;
            align-items: center;
            justify-content: space-between;
            // margin: 40px 0;
            span {
                cursor: pointer;
            }
        }
    }
    
    .regBox {
        text-align: center;
        padding: 150px 0;
        color: #555;
        
        .regIcon {
            font-size: 72px;
            margin-bottom: 10px;
            color: #4fc700;
        }
        
        .regSuccess {
            font-size: 36px;
            margin-bottom: 23px;
        }
        
        .regUsername {
            margin-bottom: 10px;
        }
        
        .regMess {
            margin: 55px 0 28px 0;
            font-size: 20px;
        }
        
        .regButton {
            button {
                padding: 7px 30px;
                cursor: pointer;
            }
            
            button:nth-child(1) {
                border: 1px solid #157efb;
                background: #fff;
                color: #157efb;
                margin-right: 90px;
            }
            
            button:nth-child(2) {
                border: none;
                background: #157efb;
                color: #fff;
            }
        }
    }
    
    .tittle {
        position: fixed;
        background: #fff;
        box-shadow: 0 -1px 0 #f0f0f0 inset;
        width: 100%;
        height: 50px;
        z-index: 9999;
        justify-content: space-around;
        align-items: center;
        
        .logo {
            // margin: 19px 42px 0 38px;
            align-items: center;
            justify-content: center;
            display: flex;
            // flex: 1;
            
            img {
                height: 33px;
                // margin: 8px 0 0 0;
                padding: 0;
            }
        }
		.titletop {
			  height: 100%;
			 padding: 0 50px 0 30px;
		  // width: 1200px;
		  justify-content: space-between;
		  align-items: center;
		  margin: 0 auto;
		}
    }
    
    .login {
        justify-content: center;
        align-items: center;
        // flex: 1;
        
        .lh90 {
            cursor: pointer;
            font-size: 13px;
        }
        
        .lh90:nth-last-child(1) {
            margin-left: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/regSuccess.vue